var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LMap",
    {
      ref: "map",
      staticStyle: { height: "100%", width: "100%", "z-index": "0" },
      attrs: {
        zoom: _vm.zoom,
        center: _vm.center,
        options: { zoomControl: false, attributionControl: false },
      },
      on: {
        "update:zoom": function ($event) {
          _vm.zoom = $event
        },
        moveend: _vm.updateCenter,
        ready: _vm.mapReady,
      },
    },
    [
      _vm._l(_vm.tileProviders, function (tile) {
        return _c("LTileLayer", {
          key: tile.name,
          attrs: {
            name: tile.name,
            visible: tile.visible,
            url: tile.url,
            attribution: tile.attribution,
            "layer-type": "base",
          },
        })
      }),
      _c("LControlLayers", { attrs: { position: "bottomleft" } }),
      _vm.layersState.Nodes && _vm.nodes.length
        ? [
            _c(
              "LLayerGroup",
              {
                attrs: { name: "Nodes" },
                on: { ready: _vm.exportNodesPosition },
              },
              _vm._l(_vm.nodes, function (node, i) {
                return _c(
                  "LMarker",
                  {
                    key: node.id,
                    ref: "node-" + node.id,
                    refInFor: true,
                    attrs: {
                      "lat-lng": node.coordinates,
                      draggable: _vm.dragMode,
                      "z-index-offset": 1000,
                      icon: _vm.circleIcon(
                        node.icon || "default",
                        "#306D8A",
                        _vm.borderColor(node)
                      ),
                    },
                    on: {
                      "update:lat-lng": function (coords) {
                        return _vm.updateNode(coords, i)
                      },
                      ready: function (element) {
                        return _vm.nodeReady(element, node.id)
                      },
                    },
                  },
                  [
                    _c(
                      "LTooltip",
                      {
                        attrs: {
                          options: {
                            permanent: true,
                            interactive: true,
                            direction: "top",
                            offset: _vm.point(0, -10),
                            className: "leaflet-tooltip-custom-style",
                          },
                        },
                      },
                      [
                        _c("span", { class: _vm.toggleTooltipClass }, [
                          _vm._v(" " + _vm._s(node.name) + " "),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ]
        : _vm._e(),
      _vm.nodeMode
        ? _c("LMarker", {
            key: "newNode",
            ref: "`newNode`",
            attrs: {
              "lat-lng": _vm.newNode,
              icon: _vm.circleIcon("default", "black"),
            },
            on: {
              "update:latLng": function ($event) {
                _vm.newNode = $event
              },
              "update:lat-lng": function ($event) {
                _vm.newNode = $event
              },
            },
          })
        : _vm._e(),
      _vm.layersState.Branches && _vm.branches.length
        ? [
            _c(
              "LLayerGroup",
              { attrs: { name: "Branches" } },
              _vm._l(_vm.branches, function (branch, i) {
                return _c("LPolyline", {
                  key: "branch-" + branch.id,
                  attrs: {
                    "lat-lngs": _vm.branchPoints[i],
                    weight: _vm.deleteMode ? 6 : 3,
                    color: _vm.voltageToColor(branch.voltage),
                    "bubbling-mouse-events": "",
                  },
                  on: {
                    ready: function (element) {
                      return _vm.branchReady(element, branch.id)
                    },
                  },
                })
              }),
              1
            ),
            _vm.editPolylineMode
              ? _c(
                  "LLayerGroup",
                  { attrs: { name: "BranchesCoordinates" } },
                  [
                    _vm._l(_vm.branches, function (branch, i) {
                      return [
                        _vm._l(branch.coordinates, function (sub, j) {
                          return _c("LMarker", {
                            key: "branch-" + i + "-subranch-" + j,
                            attrs: {
                              "lat-lng": sub,
                              draggable: "",
                              icon: _vm.svgShape("circle", "black", "black"),
                              "z-index-offset": 500,
                            },
                            on: {
                              "update:lat-lng": function (point) {
                                return _vm.updateSB(point, i, j)
                              },
                              ready: function (element) {
                                return _vm.nodeMarkerReady(element, i, j)
                              },
                            },
                          })
                        }),
                        _vm._l(
                          _vm.midPoints(_vm.branchPoints[i]),
                          function (mid, k) {
                            return _c("LMarker", {
                              key: "branch-" + i + "-newsubranch-" + k,
                              attrs: {
                                "lat-lng": mid,
                                icon: _vm.svgShape("circle", "gray", "gray"),
                              },
                              on: {
                                ready: function (event) {
                                  return _vm.markerReady(event, i, k)
                                },
                              },
                            })
                          }
                        ),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.layersState.Resources && _vm.generators.length
        ? [
            _c(
              "LLayerGroup",
              { attrs: { name: "Generators" } },
              _vm._l(_vm.generators, function (generator) {
                return _c(
                  "LMarker",
                  {
                    key: generator.id,
                    ref: "generator-" + generator.id,
                    refInFor: true,
                    attrs: {
                      "lat-lng": generator.coordinates,
                      icon: _vm.circleIcon(generator.icon, "#306D8A"),
                    },
                  },
                  [
                    _c("LPopup", [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(generator.id + " - " + generator.name) +
                            " "
                        ),
                      ]),
                    ]),
                  ],
                  1
                )
              }),
              1
            ),
          ]
        : _vm._e(),
      _vm.layersState.Resources && _vm.storages.length
        ? [
            _c(
              "LLayerGroup",
              { attrs: { name: "storages" } },
              _vm._l(_vm.storages, function (storage) {
                return _c(
                  "LMarker",
                  {
                    key: storage.id,
                    ref: "storage-" + storage.id,
                    refInFor: true,
                    attrs: {
                      "lat-lng": storage.coordinates,
                      icon: _vm.customIcon("storage"),
                    },
                  },
                  [
                    _c("LPopup", [
                      _c("div", [
                        _vm._v(
                          " " + _vm._s(storage.id + " - " + storage.name) + " "
                        ),
                      ]),
                    ]),
                  ],
                  1
                )
              }),
              1
            ),
          ]
        : _vm._e(),
      _vm.layersState.Resources &&
      _vm.layersState.Nodes &&
      _vm.resourcesBranches.length
        ? [
            _c(
              "LLayerGroup",
              { attrs: { name: "Resources Connections" } },
              _vm._l(_vm.resourcesBranches, function (branch, i) {
                return _c("LPolyline", {
                  key: i,
                  attrs: {
                    "lat-lngs": branch.latLngs,
                    weight: 2,
                    color: "#2962FF",
                  },
                })
              }),
              1
            ),
          ]
        : _vm._e(),
      _c(
        "LControl",
        { attrs: { position: "topleft" } },
        [
          _c(
            "v-btn-toggle",
            {
              staticClass: "button-direction button-location",
              attrs: { tile: "" },
              model: {
                value: _vm.mapMode,
                callback: function ($$v) {
                  _vm.mapMode = $$v
                },
                expression: "mapMode",
              },
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { right: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { value: "node" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-map-marker-plus")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Add Node")])]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { right: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { value: "branch" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-transmission-tower")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Add Transmission Line")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "LControl",
        { attrs: { position: "topleft" } },
        [
          _c(
            "v-btn-toggle",
            {
              staticClass: "button-direction",
              attrs: { tile: "" },
              model: {
                value: _vm.mapMode,
                callback: function ($$v) {
                  _vm.mapMode = $$v
                },
                expression: "mapMode",
              },
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { right: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { value: "drag" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-cursor-move")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Drag elements")])]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { right: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { value: "edit-polyline" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c("v-icon", [
                                _vm._v("mdi-vector-polyline-edit"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Edit Transmission Line")])]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { right: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                { attrs: { value: "delete" } },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-delete")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Delete elements")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "LControl",
        { staticClass: "control-layers", attrs: { position: "bottomright" } },
        [
          _c(
            "v-card",
            {
              staticStyle: { "margin-bottom": "100px" },
              attrs: { width: "100", outlined: "", elevation: "0" },
            },
            [
              _c(
                "v-row",
                { staticClass: "no-gutters" },
                [
                  _c("v-card", { staticClass: "grow", attrs: { flat: "" } }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "my-0 text-caption font-weight-medium text-center",
                      },
                      [_vm._v("Voltage (kV)")]
                    ),
                  ]),
                ],
                1
              ),
              _vm._l(_vm.branchColorRules, function (rule) {
                return _c(
                  "v-row",
                  { key: rule.color, staticClass: "no-gutters" },
                  [
                    _c(
                      "v-card",
                      { staticClass: "d-flex grow pa-1", attrs: { flat: "" } },
                      [
                        _c("v-card", {
                          attrs: {
                            color: rule.color,
                            height: "16",
                            width: "16",
                            flat: "",
                          },
                        }),
                        _c("v-spacer"),
                        _c("p", { staticClass: "mb-0 ml-1" }, [
                          _vm._v(
                            "[" +
                              _vm._s(rule.from) +
                              ", " +
                              _vm._s(rule.to) +
                              ")"
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "v-row",
                { key: "#6E6E6E", staticClass: "no-gutters" },
                [
                  _c(
                    "v-card",
                    { staticClass: "d-flex grow pa-1", attrs: { flat: "" } },
                    [
                      _c("v-card", {
                        attrs: {
                          color: "#6E6E6E",
                          height: "16",
                          width: "16",
                          flat: "",
                        },
                      }),
                      _c("v-spacer"),
                      _c("p", { staticClass: "mb-0 ml-1" }, [
                        _vm._v("Not defined"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }